import { Check, ShieldCheck } from "lucide-react";
import Reveal from "@/components/Reveal";
import { scrollToHash } from "@/components/Navbar";

const PLANS = [
  {
    id: "maintenance-plan-essential",
    name: "Essential",
    price: "$249",
    blurb: "One appliance, one annual precision tune-up.",
    features: ["1 annual precision tune-up", "21-point diagnostic inspection", "Priority scheduling", "10% off any repair"],
    featured: false,
  },
  {
    id: "maintenance-plan-total-shield",
    name: "Total Shield",
    price: "$449",
    blurb: "Whole-kitchen coverage, twice a year.",
    features: [
      "2 tune-up visits per year",
      "Coil, vent & filter deep-clean",
      "Door seal & gasket service",
      "15% off parts and labor",
    ],
    featured: true,
  },
  {
    id: "maintenance-plan-estate",
    name: "Estate",
    price: "$749",
    blurb: "Quarterly care for up to 8 appliances.",
    features: [
      "4 quarterly visits per year",
      "Covers up to 8 appliances",
      "24/7 emergency priority line",
      "20% off parts and labor",
      "Dedicated lead technician",
    ],
    featured: false,
  },
];

export default function Maintenance() {
  return (
    <section id="maintenance" data-testid="maintenance-section" className="relative py-24 sm:py-32 bg-[#171B20]/40 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E06A26] mb-5">Yearly maintenance</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight max-w-xl">
              The Shield Plans. Breakdowns prevented, not just repaired.
            </h2>
          </div>
          <p className="text-[#94A0AC] text-sm sm:text-base max-w-sm leading-relaxed">
            A yearly maintenance membership keeps fine appliances calibrated, efficient, and under warranty-friendly care.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-14">
          {PLANS.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.12}>
              <div
                data-testid={p.id}
                className={`relative rounded-2xl border p-8 sm:p-10 h-full flex flex-col transition-all duration-500 hover:-translate-y-1.5 ${
                  p.featured
                    ? "border-[#E06A26]/60 bg-[#1E242B] shadow-[0_0_50px_rgba(224,106,38,0.12)]"
                    : "border-white/10 bg-[#171B20]/90 hover:border-[#E06A26]/30"
                }`}
              >
                {p.featured && (
                  <span className="absolute -top-3 left-8 bg-[#E06A26] text-[#0F1215] font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1 rounded-full">
                    Most chosen
                  </span>
                )}
                <div className="flex items-center gap-3 mb-6">
                  <ShieldCheck className={`w-5 h-5 ${p.featured ? "text-[#E06A26]" : "text-[#94A0AC]"}`} strokeWidth={1.75} />
                  <h3 className="font-display text-xl font-semibold">{p.name}</h3>
                </div>
                <p className="font-display text-4xl font-extrabold tracking-tight">
                  {p.price}
                  <span className="font-mono text-xs text-[#606D7A] font-normal tracking-wider"> / year</span>
                </p>
                <p className="text-sm text-[#94A0AC] mt-3">{p.blurb}</p>
                <ul className="mt-8 space-y-3.5 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm text-[#F4F2EE]/85">
                      <Check className="w-4 h-4 text-[#E06A26] mt-0.5 shrink-0" strokeWidth={2.5} />
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`${p.id}-select-btn`}
                  onClick={() => scrollToHash("#contact")}
                  className={`mt-10 w-full py-3.5 rounded-full font-semibold text-sm transition-all duration-300 ${
                    p.featured
                      ? "bg-[#E06A26] hover:bg-[#F07A34] text-[#0F1215] hover:shadow-[0_0_28px_rgba(224,106,38,0.4)]"
                      : "border border-white/15 hover:border-[#E06A26]/60 text-[#F4F2EE]"
                  }`}
                >
                  Start this plan
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
